import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Icons" }, [
      _createElementVNode("path", {
        id: "Forward",
        d: "M16.0515 18.9261L9.08834 11.963L16.0515 4.99981",
        stroke: "#0F0F0F"
      })
    ], -1)
  ])))
}
export default { render: render }